import { buildQueryParams } from "../utils/query";
import { getAuthToken } from "../utils/auth";
import { config } from '../config';

export async function ListGroups(page, skip_pagination) {
  const token = getAuthToken()

  if (token === null) {
    return { data: [], pagination: {} }
  }

  let queryParams = []
  if (page) {
    queryParams.push("page=" + page)
  }
  if (skip_pagination) {
    queryParams.push("skip_pagination=1")
  }

  const response = await fetch(config.apiBaseUrl + '/rest/groups' + buildQueryParams(queryParams), {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw new Response(JSON.stringify(
      { message: 'Could not fetch groups.' },
      {
        status: 500,
      }
    ));
  }

  return await response.json();
}

export async function ReplaceInviteLink(groupId) {
  const response = await fetch(config.apiBaseUrl + '/rest/groups/' + groupId + '/invites' , {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    }
  })

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }

  if (response.status !== 423 && response.status >= 400) {
    window.location.href = '/'
  }

  const resData = await response.json()
  return { data: resData.data, status: response.status }
}

export async function LoadStandingsAuditUser(userId, groupId, standingsAuditUserPage, includeLiveMatches) {
  const token = getAuthToken()

  if (token === null || userId === null || groupId === null) {
    return {data: [], pagination: null }
  }

  const response = await fetch(config.apiBaseUrl + '/rest/groups/' + groupId + '/audit/user/' + userId + '?per_page=50&page=' + standingsAuditUserPage + (includeLiveMatches ? '&include_live_matches=1' : '')  , {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (response.status === 404) {
    return { data: [], pagination: null }
  } else if (!response.ok) {
    throw Response(JSON.stringify(
      { message: 'Could not fetch matches.' },
      { status: 500 }
    ));
  }

  return await response.json();
}


 export async function LoadStandings(groupId, currentMatchesPage) {
  const token = getAuthToken()

  if (token === null || groupId === null) {
    return {data: [], pagination: null }
  }

  const response = await fetch(config.apiBaseUrl + '/rest/groups/' + groupId + '/standings?page=' + currentMatchesPage, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (response.status >= 500) {
    throw Response(JSON.stringify(
      { message: 'Could not fetch standings.' },
      { status: 500 }
    ));
  }

  return await response.json();
}

export async function CreateGroup(group) {
  const response = await fetch(config.apiBaseUrl + '/rest/groups', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    },
    body: JSON.stringify(group)
  })

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }

  return { status: response.status, data: (await response.json())}
}

export async function SaveGuessGroup(groupId, guess) {
  const response = await fetch(config.apiBaseUrl + '/rest/groups/' + groupId + '/bets' , {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    },
    body: JSON.stringify(guess)
  })

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }

  return { status: response.status, data: (await response.json())}
}

export async function GetCurrentInvite(groupID) {
  const token = getAuthToken()

  const response = await fetch(config.apiBaseUrl + '/rest/groups/' + groupID + '/invites', {
    headers: {
      'content-type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }

  return { status: response.status, data: (await response.json())}
}


export async function LoadStandingsAuditMatch(match, groupId, standingsAuditMatchPage) {
  const token = getAuthToken()

  if (token === null || match === null || groupId === null) {
    return {data: [], pagination: null }
  }

  const response = await fetch(config.apiBaseUrl + '/rest/groups/' + groupId + '/audit/match/' + match.id + '?per_page=50&page=' + standingsAuditMatchPage, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (response.status === 404) {
    return {data: [], pagination: null }
  } else if (!response.ok) {
    throw Response(JSON.stringify(
      { message: 'Could not fetch matches.' },
      { status: 500 }
    ));
  }

  return await response.json();
}


export async function AcceptInvitationGroup(groupId, inviteToken) {
  const token = getAuthToken()

  const response = await fetch(config.apiBaseUrl + '/rest/groups/' + groupId + '/invites/' + inviteToken + '/accept', {
    headers: {
      'content-type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })

  if (response.status === 400 || response.status === 404) {
    return response
  }

  if (!response.ok) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }

  return null
}

export async function LoadCurrentUserPointsGroups(groupId) {
  const token = getAuthToken()

  if (token === null || groupId === null) {
    return {data: {}}
  }

  const response = await fetch(config.apiBaseUrl + '/rest/groups/' + groupId + '/me', {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw Response(JSON.stringify(
      { message: 'Could not fetch current user points.' },
      { status: 500 }
    ));
  }

  return await response.json();
}


export async function BlockUserGroups(groupId, userId) {
  return await ManageUserGroups(groupId, userId, 'PUT');
}

export async function UnblockUserGroups(groupId, userId) {
  return await ManageUserGroups(groupId, userId, 'DELETE');
}

async function ManageUserGroups(groupId, userId, method) {
  const token = getAuthToken()

  if (token === null || groupId === null || userId === null) {
    return {data: {}}
  }

  const response = await fetch(config.apiBaseUrl + '/rest/groups/' + groupId + '/block?user_id=' + userId, {
    method: method,
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw Response(JSON.stringify(
      { message: 'Could not fetch current user points.' },
      { status: 500 }
    ));
  }

  return await response.json();
}

export async function ListUsersGroups(groupId) {
  const token = getAuthToken()

  if (token === null || groupId === null) {
    return {data: {}}
  }

  const response = await fetch(config.apiBaseUrl + '/rest/groups/' + groupId + '/users', {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw Response(JSON.stringify(
      { message: 'Could not fetch current user points.' },
      { status: 500 }
    ));
  }

  return await response.json();
}
